import React, { Component } from 'react';

import HexDescription from "./HexDescription";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip'
import $ from 'jquery';
import Ajax from '../ajax/Ajax';

class Island extends Component {
	
	constructor(props) {
		super(props);
		var key = props.match.params.key;
		var editable = key === "broccoli";
		this.state = {info: {}, editable: editable, hexDescription: false, clicked: false, hexId: false};
		
		this.updateInfo = this.updateInfo.bind(this);
		this.showHexDescription = this.showHexDescription.bind(this);
	}
	
	componentWillMount() {
		var obj = this;
		Ajax.getIsland().then(function(info) {
			obj.setState({info: info});
		});
	}
	
	updateInfo(hexId, description) {
		var obj = this;
		Ajax.getIsland().then(function(info) {
			info[hexId] = description;
			var hexDescription = description;
			Ajax.postIsland(info).then(() => {
				obj.setState({info: info, hexDescription: hexDescription});
			});			
		});
	}
	
	showHexDescription(hexId) {
		var obj = this;
		var info = this.state.info;
		return function(event) {
			var description = info[hexId];
			if (typeof description === "undefined")
				description = false;
			obj.setState({hexId: hexId, hexDescription: description, clicked: true});
			$(".HexagonSelected").removeClass("HexagonSelected");
			$("#" + hexId).addClass("HexagonSelected");
		}
	}
	
	render() {
		var hexes = new Array(273);
		for (var i = 0; i < hexes.length; i++) {
			hexes[i] = i;
		}
		
		var info = this.state.info;
		var description = this.state.hexDescription;
		var hexId = this.state.hexId;
		var edit = this.state.editable;
		var clicked = this.state.clicked;
		var obj = this;
		  
		return (
		<div className="Island">		
			<div className="Map">
				{info ? hexes.map(function(hex, idx) {
						var currentHexId = "hex" + idx;
						var hexInfo = info[currentHexId];						
						if (! (typeof hexInfo === "undefined")) {
							var title = hexInfo.title;
							if (! ((typeof title === "undefined") || (title === "Titre")))
								return (<div key={idx} id={currentHexId} className="Hexagon" onClick={obj.showHexDescription(currentHexId)} data-for={"tooltip-" + currentHexId} data-tip={title}></div>);
							else 
								return (<div key={idx} id={currentHexId} className="Hexagon" onClick={obj.showHexDescription(currentHexId)}></div>);
						}
						else {
							return (<div key={idx} id={currentHexId} className="Hexagon" onClick={obj.showHexDescription(currentHexId)}></div>);
						}
					}) : null
				}				
			</div>
			<div className="Icons">
				{info ? hexes.map(function(hex, idx) {
						var currentHexId = "hex" + idx;
						var hexInfo = info[currentHexId];						
						if (! (typeof hexInfo === "undefined")) {
							var icon = hexInfo.icon;
							if (! (typeof icon === "undefined"))
								return (<div key={idx} id={currentHexId} onClick={obj.showHexDescription(currentHexId)} className="Icon"><FontAwesomeIcon icon={icon}/></div>);
							else
								return (<div key={idx} id={currentHexId} onClick={obj.showHexDescription(currentHexId)} className="Icon"></div>);
						}							
						else return (<div key={idx} id={currentHexId} onClick={obj.showHexDescription(currentHexId)} className="Icon"></div>);
					}) : null
				}
			</div>
			<HexDescription hexId={hexId} description={description} edit={edit} selected={clicked} update={obj.updateInfo}/>
			<div>
			{info ? hexes.map(function(hex, idx) {
					var currentHexId = "hex" + idx;
					var hexInfo = info[currentHexId];						
					if (! (typeof hexInfo === "undefined")) {
						var title = hexInfo.title;
						if (! ((typeof title === "undefined") || (title === "Titre")))
							return (<ReactTooltip id={"tooltip-" + currentHexId} effect="solid" className="IslandTooltip" />);
						else 
							return null;
					}
					else {
						return null;
					}
				}) : null
			}
			</div>
		</div>
		
		);
	}
}

export default Island;



// WEBPACK FOOTER //
// ./src/components/Island.js